import { useEffect, useState } from "react";
import { TaskContext } from "../../TasksTypes";
import { TaskTypeBlock } from "../../TaskTypeBlock";
import { trueFriendsForm } from "../../../../utils/true.word.form";
import { useSelector } from "../../../../hooks";
import friendsIcon from "./icons/friends.png";
import styles from "../../Block.module.scss";
import { useContextNavigate } from "../../../../hooks/navigate";

export const InviteBlock = () => {
    const [friendsCount, setFriendsCount] = useState<number | undefined>(undefined);

    const { items: referals } = useSelector(store => store.referals);
    const referalsCount = useSelector(store => store.tasks.referalsCount);

    useEffect(() => {
        const friendsCount = referals?.length ? referals.length : referalsCount;        
        setFriendsCount(friendsCount);
    }, [setFriendsCount, referalsCount, referals]);

    const navigate = useContextNavigate<TaskContext>();

    const getFriendsDescription = () => friendsCount
        ? <>Приглашено <span className={styles.invitedCount}>{friendsCount}</span> {trueFriendsForm(friendsCount ?? 0)}</>
        : 'Пока никто не приглашен';

    return (
        <TaskTypeBlock
            handler={ () => navigate(TaskContext.Invite) }
            name='Пригласить друзей'
            icon={friendsIcon}
            description={ getFriendsDescription() }
            iconTypeStyle='iconTypeFriends'
        />
    );
}